export enum SurveyLogoPlacement {
	Left = 1,
	Center = 2,
}
